/* 
  调用方式demo:
  const tabs: Array<Item> = [
    {
      name: 'tab1',
      panel: <div>1</div>,
      disabled: false
    },
    {
      name: 'tab2',
      panel: <div>2</div>,
      disabled: false
    },
    {
      name: 'tab3',
      panel: <div>3</div>,
      disabled: false
    }
  ]
  <Tabs tabs={tabs} handleChangePanel={handleChangePanel}/>
*/

/* 
  调用方式demo2:
  const tabs: Array<Item> = [
    {
      name: 'tab1',
      disabled: false
    },
    {
      name: 'tab2',
      disabled: false
    },
    {
      name: 'tab3',
      disabled: false
    }
  ]
  <Tabs tabs={tabs} handleChangePanel={handleChangePanel}><Panel></Panel></Tabs>
*/
import React, { useState, ReactNode, useEffect} from "react";
interface Item {
  name: string, // 选项卡name
  panel?: ReactNode | ReactNode[], // 当前name对应的选项卡内容
  disabled?: boolean, // 是否不可选中
}
const Tab: React.FC<{
  tabs: Array<Item>;
  handleChangePanel?: (curr: Item) => void;
  children?: ReactNode;
}> = ({tabs, handleChangePanel, children}) => {
  // 当前选中的tab标签
  const [selectedName, setSelectedName] = useState<string>(tabs[0].name)
  // 当前选中的tab标签 对应的面板
  const [selectedPanel, setSelectedPanel] = useState<ReactNode | ReactNode[]>(tabs[0].panel)
  // tabs-bar
  const [tabsBarWidth, setTabsBarWidth] = useState<number>()
  const [tabsBarLeft, setTabsBarLeft] = useState<number>()
  useEffect(() => {
    setTabsBarWidth(document.getElementById(selectedName)?.offsetWidth)
    setTabsBarLeft(document.getElementById(selectedName)?.offsetLeft)
  }, [selectedName])

  const clickHandle = (item: Item) => {
    if (item.disabled) return
    setSelectedName(item.name)
    setSelectedPanel(item.panel)
    handleChangePanel?.(item)
  }
  return (
    <div className="">
      {/* tabs name 动态生成Tab导航*/}
      <ul className="flex border-b border-gray-200 dark:border-gray-700 relative">
        {tabs.map((item: any) => (
          <li
            className={`mr-2 py-4 px-4 text-sm font-medium text-center border-b-2 border-transparent
              ${item.name === selectedName ? 'text-sprimary-600  hover:text-sprimary-600 ' : ''}
              ${item.disabled ? 'cursor-not-allowed text-gray-300' : 'cursor-pointer text-gray-600 hover:text-gray-600'}
            `}
            id={item.name}
            key={item.name}
            onClick={() => clickHandle(item)}
          >
            {item.name}
          </li>
        ))}
      <div className="absolute bottom-0 border-b-2 border-sprimary-600 transition-all duration-200" style={{width: tabsBarWidth + 'px', left: tabsBarLeft + 'px'}}></div>
      </ul>
      {/* Tab内容区域 当前标签页的展示内容 */}
      {selectedPanel ? selectedPanel : children}
    </div>
  )
}
export default Tab